import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import {
    FETCH_15MIN_REQUESTED,
    FETCH_1HOUR_REQUESTED,
    FETCH_6HOUR_REQUESTED,
} from './constants';
import { getMonitorDetail } from '../../api';
import {
    fetch15MinSucceeded,
    fetch15MinFailed,
    fetch1HourSucceeded,
    fetch1HourFailed,
    fetch6HourSucceeded,
    fetch6HourFailed,
} from './actions';
import { parseClientError } from '../../api/utils';
import {
    getStartDate15Min,
    getEndDate15Min,
    getStartDate1Hour,
    getEndDate1Hour,
    getStartDate6Hour,
    getEndDate6Hour,
} from './selectors';

function* get15MinData() {
    try {
        const startDate = yield select(getStartDate15Min);
        const endDate = yield select(getEndDate15Min);
        const monitoringData = yield call(getMonitorDetail, {
            startDate,
            endDate,
        });
        yield put(fetch15MinSucceeded(monitoringData));
    } catch (e) {
        Sentry.captureException(e);
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(fetch15MinFailed(message));
    }
}

function* get1HourData() {
    try {
        const startDate = yield select(getStartDate1Hour);
        const endDate = yield select(getEndDate1Hour);

        const monitoringData = yield call(getMonitorDetail, {
            startDate,
            endDate,
        });

        yield put(fetch1HourSucceeded(monitoringData));
    } catch (e) {
        Sentry.captureException(e);
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(fetch1HourFailed(message));
    }
}

function* get6HourData() {
    try {
        const startDate = yield select(getStartDate6Hour);
        const endDate = yield select(getEndDate6Hour);

        const monitoringData = yield call(getMonitorDetail, {
            startDate,
            endDate,
        });

        yield put(fetch6HourSucceeded(monitoringData));
    } catch (e) {
        Sentry.captureException(e);
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(fetch6HourFailed(message));
    }
}

export default function*() {
    yield all([yield takeLatest(FETCH_15MIN_REQUESTED, get15MinData)]);
    yield all([yield takeLatest(FETCH_1HOUR_REQUESTED, get1HourData)]);
    yield all([yield takeLatest(FETCH_6HOUR_REQUESTED, get6HourData)]);
}
